import { Controller, useFormContext } from 'react-hook-form'

import {
  AppButton,
  AppDivider,
  AppFormInput,
  AppFlexContainer,
  AppFlexItem,
  AppForm,
} from 'client/ui-building-blocks'

import { QuestionCategorySelect } from 'client/components'

type Props = {
  isFetchingQuestionProposal: boolean
  onGenerateQuestionBtnClick: () => void
}

export const DataManagerForm = ({
  isFetchingQuestionProposal = false,
  onGenerateQuestionBtnClick,
}: Props) => {
  const { control } = useFormContext()

  return (
    <AppForm onSubmit={onGenerateQuestionBtnClick}>
      <AppFlexContainer alignItems="flex-end" rowGap="30px">
        <AppFlexItem flexGrow={1}>
          <AppFlexContainer alignItems="flex-end" columnGap="10px" rowGap="20px">
            <AppFlexItem flexGrow={1}>
              <QuestionCategorySelect isDisabled={isFetchingQuestionProposal} />
            </AppFlexItem>
            <AppFlexItem flexGrow={1}>
              <Controller
                control={control}
                name="subject"
                disabled={isFetchingQuestionProposal}
                render={({ field: { value, onChange } }) => {
                  return (
                    <AppFormInput
                      value={value}
                      label="Subject"
                      placeholder="..."
                      disabled={isFetchingQuestionProposal}
                      onChange={onChange}
                    />
                  )
                }}
              />
            </AppFlexItem>
          </AppFlexContainer>
        </AppFlexItem>
        <AppFlexItem flexGrow={3}>
          <AppButton
            type="submit"
            variant="info"
            text="Generate question"
            position="right"
            loading={isFetchingQuestionProposal}
            disabled={isFetchingQuestionProposal}
          />
        </AppFlexItem>
      </AppFlexContainer>
      <AppDivider size="small" />
    </AppForm>
  )
}
